import { Pagination, PaginationProps } from 'antd';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isLocaleEnglish } from 'utils';

const CustomPagination = (props: PaginationProps) => {
  const { i18n } = useTranslation();

  /**
   * Change text of amount items per page because of unsupported from Antd
   * Default value of Atnd in chinese {amount} 條/頁
   * but expected is {amount}/頁
   */
  const changeText = useCallback(
    (elements: HTMLCollectionOf<Element>) => {
      if (elements?.length && !isLocaleEnglish(i18n.language)) {
        for (let index = 0; index < elements.length; index++) {
          const text = (elements[index] as HTMLElement).innerText;
          (elements[index] as HTMLElement).innerText = text.replace(' 條', '');
        }
      }
    },
    [i18n.language],
  );

  useEffect(() => {
    const elements = document.getElementsByClassName('ant-select-selection-item');
    changeText(elements);
    const amountPerPage = document.getElementsByClassName('ant-pagination-options');
    if (amountPerPage?.length) {
      amountPerPage[0].addEventListener('click', function () {
        const optionElements = document.getElementsByClassName('ant-select-item-option-content');
        changeText(optionElements);
      });
    }
  }, [changeText]);

  return <Pagination {...props} />;
};

export default CustomPagination;
